module.exports = __webpack_public_path__ + "static/ms-icon-144x144-53cb3775550e500b86662f53c324e01a.png";